import React from "react";
import { IconButton, Typography } from "@mui/material";
import LaunchIcon from '@mui/icons-material/Launch';

interface StyledIconButtonProps {
    appTheme: any;
    label: string;
    factor: number;
    color: string;
    icon: React.ReactNode;
    onClick: () => void;
    width?: number | string;
    height?: number | string;
    fill?: string;
    disabled?: boolean;
    radius?: number;
}

export const StyledIconButton = ({ appTheme, label, factor, color, icon, onClick, width, height, disabled, fill, radius }: StyledIconButtonProps) => {
    return (
        <IconButton
            disabled={disabled || false}

            sx = {{
                width: width || '100%',
                height: height || '100%',
                borderRadius: radius || 2,
                padding: 0.5,
                justifyContent: radius ? 'center' : 'flex-start',
                backgroundColor: fill ? appTheme.palette[color][fill] : 'transparent',
                border: fill ? `1px solid ${appTheme.palette[color].main}` : '1px solid transparent',
                '&:hover': {backgroundColor: appTheme.palette[color].extraLight},
                '&:active': {backgroundColor: 'transparent'},
                '&:focus': {backgroundColor: 'transparent'},
                '&:disabled': {backgroundColor: 'whitesmoke'},
                '& .MuiTouchRipple-ripple': {
                    color: appTheme.palette[color].light,
                    width: '100%',
                }


            }}
            onClick={onClick}
            >
                <Typography variant='subtitle2' 
                    color={ disabled ? 'darkgray' : `${appTheme.palette[color].main}`} 
                    sx={{ 
                        fontWeight: 500, 
                        fontSize: 14*factor, 
                        display: 'flex', 
                        alignItems: 'center', 
                        textAlign: 'left', 
                        justifyItems: 'center' 
                    }}
                >
                    {icon} {label}
                </Typography>
            </IconButton>
    )
}

